export default __webpack_public_path__ + "static/jellow-right-min-3f208358e32c57a2389803a5136d21c0.png";